import React from 'react';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTwitter, 
  faInstagram, 
  faLinkedin, 
  faYoutube 
} from '@fortawesome/free-brands-svg-icons';
import { faCopyright } from '@fortawesome/free-solid-svg-icons';
import './Footer.css';

const Footer = () => {
  const location = useLocation();
  const isEnglish = location.pathname.startsWith('/en');

  return (
    <footer className="footer">
      <div className="container">
        <h4>{isEnglish ? 'About Us' : 'Hakkımızda'}</h4>
        <p>{isEnglish ? 'Our Social Media Accounts' : 'Sosyal medya hesaplarımız'}</p>
        <div className="social-icons">
          <a href="https://x.com/ProgenX_Academy" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
            <FontAwesomeIcon icon={faTwitter} />
          </a>
          <a href="https://www.instagram.com/progenxacademy/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a href="https://tr.linkedin.com/company/progenx-academy" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
          <a href="https://www.youtube.com/channel/UCRyqFfyAXKryEDgLXc2s3og" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <FontAwesomeIcon icon={faYoutube} />
          </a>
        </div>
        <p className="copyright">
          {isEnglish ? 'All Rights Reserved.' : 'Tüm Hakları Saklıdır.'} <FontAwesomeIcon icon={faCopyright} /> ProgenX Eğitim ve Bilişim Teknolojileri A.Ş.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
